import React, { useState } from "react";
import { useEffect } from "react";
import Mynftpage from "../mynfts"
import { addDoc, Timestamp, collection, getDocs, setDoc, doc, query } from "firebase/firestore";
import { db } from "../firebase";


const WestStaking = () => {
  const [firebaseData, setfirebaseData] = useState([])
  const [selectedZoneValue, setselectedZoneValue] = useState("")
  console.log(window.location.pathname);


  const getFirebasedata = async () => {
    const q = query(collection(db, "RewardInfo"));
    const querySnapshot = await getDocs(q);
    var temp = {}
    querySnapshot.forEach((doc) => {
      temp[doc.id] = Object.values(doc.data())[0]
    });
    setfirebaseData(temp)
  }

  useEffect(() => {
    getFirebasedata()
  }, [])

  useEffect(() => {
    if (window.location.pathname == "/weststake") {
      // console.log("it is west zone", firebaseData.West);
      setselectedZoneValue(firebaseData.West)
    }
  }, [firebaseData])
  return (
    <Mynftpage zone="west" reward={selectedZoneValue} />
  );
};
export default WestStaking;
